module.exports = __webpack_public_path__ + "d427526ce2828a911736937d13063ead.png";